import {
  TableBuildingCell,
  TableBuildingGroupsListCell,
  TableDateCell,
  TableFlatCell,
  TableProviderListCell,
  TableTextCell,
  TableUserCell,
  toTableBuildingGroupsListCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'
import { TaskTableCellName, TaskTableItemCommitType } from '../Task.enums'
import { isTaskDone } from '../Task.utils'
import { TaskTableRowDeadline } from '../TaskTableRowDeadline'
import { TaskTableRowDoneStatus } from '../TaskTableRowDoneStatus'
import { TaskTableRowPriority } from '../TaskTableRowPriority'
import { TaskTableRowRequest } from '../TaskTableRowRequest'
import { TaskTableRowTitle } from '../TaskTableRowTitle'
import { TaskTableRowVisibility } from '../TaskTableRowVisibility'
import { TaskTableRowYesNoStatus } from '../TaskTableRowYesNoStatus'

export function renderTaskTableCell({
  disabled,
  hideAutomationsTag,
  isLoading,
  item,
  name,
  scrollRef,
  onChangeStatus,
  onChangeVisibility,
  onClickEmailTag,
  onClickFileTag,
  ...restProps
}) {
  const { commit_type: commitType, [name]: value } = item

  const done = isTaskDone(item)

  switch (name) {
    case TaskTableCellName.ActivityType:
    case TaskTableCellName.Category:
    case TaskTableCellName.Phase:
      return <TableTextCell {...restProps} done={done} value={value?.name} />

    case TaskTableCellName.Building:
      return (
        <TableBuildingCell
          {...restProps}
          isSingleValue
          done={done}
          value={value}
        />
      )

    case TaskTableCellName.BuildingGroups:
      return (
        <TableBuildingGroupsListCell
          {...restProps}
          done={done}
          scrollRef={scrollRef}
          value={value?.map(toTableBuildingGroupsListCell)}
        />
      )

    case TaskTableCellName.Created:
    case TaskTableCellName.ClosedAt:
    case TaskTableCellName.Updated:
      return <TableDateCell {...restProps} done={done} value={value} />

    case TaskTableCellName.ClosedBy:
    case TaskTableCellName.CreatedBy:
    case TaskTableCellName.Manager:
    case TaskTableCellName.RequestOwner:
    case TaskTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...restProps}
          done={done}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case TaskTableCellName.Contractors:
      return (
        <TableProviderListCell
          {...restProps}
          done={done}
          scrollRef={scrollRef}
          value={value?.map(toUserMultiValue)}
        />
      )

    case TaskTableCellName.Deadline:
      return <TaskTableRowDeadline {...restProps} item={item} />

    case TaskTableCellName.Flat:
      return <TableFlatCell {...restProps} done={done} value={value} />

    case TaskTableCellName.Priority:
      return <TaskTableRowPriority {...restProps} item={item} />

    case TaskTableCellName.Request:
      return <TaskTableRowRequest {...restProps} item={item} />

    case TaskTableCellName.Status:
      switch (commitType) {
        case TaskTableItemCommitType.Done:
          return (
            <TaskTableRowDoneStatus
              {...restProps}
              disabled={disabled}
              isLoading={isLoading}
              item={item}
              onChange={onChangeStatus}
            />
          )
        case TaskTableItemCommitType.YesNo:
          return (
            <TaskTableRowYesNoStatus
              {...restProps}
              disabled={disabled}
              isLoading={isLoading}
              item={item}
              onChange={onChangeStatus}
            />
          )

        default:
          throw new Error('Invalid commit type')
      }

    case TaskTableCellName.Title:
      return (
        <TaskTableRowTitle
          {...restProps}
          hideAutomationsTag={hideAutomationsTag}
          item={item}
          onClickEmailTag={onClickEmailTag}
          onClickFileTag={onClickFileTag}
        />
      )

    case TaskTableCellName.VisibleToTenant:
      return (
        <TaskTableRowVisibility
          {...restProps}
          isLoading={isLoading}
          item={item}
          onChange={onChangeVisibility}
        />
      )

    default:
      return null
  }
}
